import { RETURN_TO } from '@User/LoginPage/constants'

import { isJapan, isUs } from '~/lib/appRegionConstants'
import { HELP_EMAIL } from '~/lib/emailAndUrls'
import { mailtoLink } from '~/lib/mailtoLink'
import { getenv } from '~/settings'

export const PLACEMENT = 'sign-up'
export const FIRST_NAME = 'first-name'
export const LAST_NAME = 'last-name'
export const COMPANY = 'company'
export const PASSWORD = 'password'
export const PHONE_NUMBER = 'phone-number'
export const EMAIL = 'email'
export const LOCATION = 'country-or-state' as const
export const SUBSCRIBE = 'subscribe'
export const UTM_CAMPAIGN = 'utm_campaign'
export const SIGN_UP = 'sign_up'

export const QUERY_STRING = 'queryString'
export const ORIGINAL_REFERRER = 'originalReferrer'
export const PAGE_URL = 'pageUrl'

export const LOCATION_RULE = [
    {
        required: true,
        message: 'Location required',
    },
]

export const BUSINESS_ACCOUNT_INVITE_TOKEN = 'business_account_invite_token'
export const BUSINESS_ACCOUNT_NAME = 'company_name'
export const BUSINESS_ACCOUNT_RECIPIENT_EMAIL = 'recipient_email'
export const BUSINESS_ACCOUNT_SENDER_EMAIL = 'sender_email'
export const BUSINESS_ACCOUNT_SENDER_NAME = 'sender_name'
export const BUSINESS_ACCOUNT_INVITE_EXPIRE_DATE = 'expiry_date'
export const BUSINESS_ACCOUNT_EXPIRED_INVITE_TOKEN_ERROR = 'Invitation expired'
export const BUSINESS_ACCOUNT_EXPIRED_INVITATION_URL =
    '/expired-business-account-invitation'
export const QUOTE_INVITE_TOKEN = 'project_invite_token' // update to quote_invite_token once graphql supports
export const QUOTE_ID = 'folder_id' //update to quote_id once graphql supports
export const INVITED_BY = 'invited_by'
export const INVITED_EMAIL = 'invited_email'
export const USE_COUNTRIES = 'use_countries'
const COUPON_TOKEN = 'coupon_token'
const REFERRAL_TOKEN = 'referral_token'

export const PUNCHOUT_SESSION_ID = 'punchout_session_id'

export const PHONE_NUMBER_REMOVED = 'no_phone'
export const MULTI_STEP_FORM = 'multi_step'

export const PARAMS = [
    QUOTE_INVITE_TOKEN,
    COUPON_TOKEN,
    REFERRAL_TOKEN,
    RETURN_TO,
    QUOTE_ID,
    INVITED_BY,
    INVITED_EMAIL,
    BUSINESS_ACCOUNT_INVITE_TOKEN,
    BUSINESS_ACCOUNT_NAME,
    BUSINESS_ACCOUNT_RECIPIENT_EMAIL,
    BUSINESS_ACCOUNT_SENDER_EMAIL,
    BUSINESS_ACCOUNT_SENDER_NAME,
    BUSINESS_ACCOUNT_INVITE_EXPIRE_DATE,
    UTM_CAMPAIGN,
    PHONE_NUMBER_REMOVED,
]

const COMPANY_MIN = 3
const COMPANY_MAX = 64

export const COMPANY_RULES = [
    { required: true, message: 'Required' },
    {
        min: COMPANY_MIN,
        message: `Company must be minimum ${COMPANY_MIN} characters.`,
    },
    {
        max: COMPANY_MAX,
        message: `Company cannot exceed ${COMPANY_MAX} characters`,
    },
]

export const linkText = () => {
    if (isJapan()) {
        return 'Help'
    } else if (isUs()) {
        return 'Learn more.'
    }
}

export const href = () => {
    if (isJapan()) {
        return `${mailtoLink(HELP_EMAIL, 'I need help!')}`
    } else if (isUs()) {
        return `${
            getenv('REGIONAL_CONFIGS')?.urls
                ?.how_do_you_handle_ip_confidentiality
        }`
    }
}

export interface SignupFormValues {
    email: string
    password: string
    'first-name': string
    'last-name': string
    company: string
    'phone-number': string
    [LOCATION]: string
    subscribe: boolean
    businessAccountInviteToken: string | undefined
}
